import { Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getCitiesByState,
  getCountries,
  getStatesByCountry,
  resetCityField,
  resetStateField,
} from "../../redux/slice/form-field/formFieldSlice";

import { getSearchProviders } from "../../redux/slice/provider-search/searchProvidersSlice";
import { setLocalStorageItem } from "../../service/utils";
import Button from "./form-fields/Button";
import DropdownField from "./form-fields/DropdownField";
import InputField from "./form-fields/InputField";
import { t } from "i18next";

const RefineNetworkSearchForm = ({ providerData, setProviderData }) => {
  const initialValues = {
    countrySearch: providerData.countrySearch ? providerData.countrySearch : "",
    stateSearch: providerData.stateSearch ? providerData.stateSearch : "",
    citySearch: providerData.citySearch ? providerData.citySearch : "",
    zipSearch: providerData.zipSearch ? providerData.zipSearch : "",
    organizationSearch: providerData.organizationSearch
      ? providerData.organizationSearch
      : "",
  };

  const dispatch = useDispatch();
  const { countriesData, statesData, citiesData } = useSelector(
    (state) => state.formField
  );

  useEffect(() => {
    dispatch(getCountries());
  }, []);

  const handleCountryChange = (event, setValues) => {
    const selectedCountryId = event.target.value;
    if(selectedCountryId){
      dispatch(getStatesByCountry(selectedCountryId));
    }else{
      dispatch(resetStateField());
      dispatch(resetCityField());
    }
    setProviderData({
      ...providerData,
      countrySearch: selectedCountryId,
      stateSearch: "",
      citySearch: "",
    });
    setValues({
      countrySearch: selectedCountryId,
      stateSearch: "",
      citySearch: "",
      zipSearch: "",
      organizationSearch: "",
    });
  };

  const handleStateChange = (event, values, setValues) => {
    const selectedStateId = event.target.value;
    const selectedCountry = values.countrySearch;
    const payload = {
      country: selectedCountry,
      state: selectedStateId
    }
    selectedStateId && dispatch(getCitiesByState(payload));
    if(selectedStateId){
      dispatch(getCitiesByState(payload));
    }else{
      dispatch(resetCityField());
    }
    setProviderData({
      ...providerData,
      stateSearch: selectedStateId,
      citySearch: "",
    });
    setValues({
      stateSearch: selectedStateId,
      citySearch: "",
      zipSearch: "",
      organizationSearch: "",
    });
  };

  return (
    <div className="col-md-3 argusnetwork-search padding-none">
      <div className="col-md-12 sideheading">
        <i className="bars-icon" aria-hidden="true"></i>
        {t("refine-your-search")}
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          const payload = {
            delta: 10,
            pageNumber: 1,
            sortDirection: 1,
            isDownloadPdf: false,
            countrySearch: values.countrySearch,
            stateSearch: values.stateSearch,
            citySearch: values.citySearch,
            zipSearch: values.zipSearch,
            addressSearch: null,
            specialitySearch: "",
            organizationSearch: values.organizationSearch,
            isSpecialitySearch: false,
          };

          dispatch(getSearchProviders(payload));
          setLocalStorageItem("searchValues", {
            ...payload,
          });
        }}
        enableReinitialize
      >
        {({ values, handleSubmit, handleChange, setValues }) => (
          <form onSubmit={handleSubmit} className="ng-pristine ng-valid">
            <div className="form-group">
              <div className="col-md-12 argusnetwork-form">
                <DropdownField
                  name="countrySearch"
                  placeHolder={t("country-placeholder")}
                  options={countriesData}
                  value={values.countrySearch}
                  onChange={(event) => handleCountryChange(event, setValues)}
                />
              </div>
              <div className="col-md-12 argusnetwork-form">
                <DropdownField
                  name="stateSearch"
                  placeHolder={t("state-province-placeholder")}
                  options={statesData}
                  value={values.stateSearch}
                  onChange={(event) => handleStateChange(event, values, setValues)}
                />
              </div>
              <div className="col-md-12 argusnetwork-form">
                <DropdownField
                  name="citySearch"
                  placeHolder={t("city-placeholder")}
                  options={citiesData}
                  value={values.citySearch}
                  onChange={(event) => {
                    handleChange(event);
                    setProviderData({
                      ...providerData,
                      citySearch: event.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-md-12 argusnetwork-form">
                <InputField
                  name="zipSearch"
                 placeholder={t("enter-zip-postal-code-placeholder")}
                  type="text"
                  value={values.zipSearch}
                  onChange={(event) => {
                    handleChange(event);
                    setProviderData({
                      ...providerData,
                      zipSearch: event.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-md-12 argusnetwork-form">
                <InputField
                  name="organizationSearch"
                  placeholder={t("enter-organization-name-placeholder")}

                  type="text"
                  value={values.organizationSearch}
                  onChange={(event) => {
                    handleChange(event);
                    setProviderData({
                      ...providerData,
                      organizationSearch: event.target.value,
                    });
                  }}
                />
              </div>
              <div className="span9 btn-block argusnetwork-form">
                <Button
                  isIcon={false}
                  buttonText={t("search-button")}
                  buttonType={"submit"}
                  className={"btn btn-large btn-block btn-search"}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default RefineNetworkSearchForm;
